import { CSSProperties } from 'react';
import { Color } from '@vivli/shared/theme';
import { ButtonView } from './button.view';
import { AssetsConstant, DTICommonConst } from '@vivli/shared/infrastructure/constants';
import { LoadIndicatorView } from '../load-indicator/load-indicator.view';

interface ExportCsvButtonProps {
    onClick: (e) => void;
    style?: CSSProperties;
    title?: string;
    isLoading?: boolean;
    showDownloadingText?: boolean;
}

const buttonStyle: CSSProperties = {
    background: 'transparent',
    color: Color.VIVLI_BLUE,
    boxShadow: 'none',
    minWidth: '60px',
    paddingLeft: '0px',
};

export const ExportCsvButtonView = (props: ExportCsvButtonProps) => {
    const { onClick, style, title, isLoading, showDownloadingText } = props;

    const handleOnClick = (e) => {
        if (!isLoading) {
            onClick(e);
        }
    };

    return (
        <div data-test-id={DTICommonConst.ExportCsvButton} style={{ ...style }}>
            {isLoading && showDownloadingText && <span style={{ marginRight: '10px' }}>Downloading...</span>}
            <ButtonView
                onClick={handleOnClick}
                style={buttonStyle}
                title={title || 'Export CSV'}
                dataId={DTICommonConst.HeaderApprovalButton('ExportCSV')}
                disabled={isLoading}
            >
                {isLoading && <LoadIndicatorView />}
                {!isLoading && <img src={AssetsConstant.DOWNLOAD_ARROW} style={{ height: '25px' }} />}
            </ButtonView>
        </div>
    );
};
